// Custom buttons

import { ArrowLeftOutlined, ArrowRightOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router";


export const CustomRunButton = ({ children, onClick = () => true, disabled = false, width = "100%" }) => {

    // Common run-button style
    const buttonStyle = {
        backgroundColor: "var(--primary-color-2)",
        color: "var(--button-text-color)",
        fontWeight: "var(--button-font-weight-strong)",
        border: 0,
        width: width
    };

    if (disabled)
        return (<Button style={{ ...buttonStyle, backgroundColor: "var(--disabled-color-1)", color: "var(--text-color-1)" }} disabled>{children}</Button>)

    else
        return (<Button onClick={onClick} style={buttonStyle}>{children}</Button>)

}

export const CustomGeneralButton = ({ children, onClick = () => true, disabled = false }) => {

    // Common general-button style
    const buttonStyle = {
        backgroundColor: "var(--primary-color-2)",
        color: "var(--button-text-color)",
        fontWeight: "var(--button-font-weight-strong)",
        border: 0,
    };

    if (disabled)
        return (<Button style={{ ...buttonStyle, backgroundColor: "var(--disabled-color-1)", color: "var(--text-color-1)" }} disabled>{children}</Button>)

    else
        return (<Button onClick={onClick} style={buttonStyle}>{children}</Button>)

}


export const CustomGoButton = ({ children, onClick = () => true, disabled = false }) => {

    // Common run-button style
    const buttonStyle = {
        backgroundColor: "var(--primary-color-2)",
        color: "var(--button-text-color)",
        fontWeight: "var(--button-font-weight-strong)",
        border: 0,
    };

    if (disabled)
        return (<Button style={{ ...buttonStyle, backgroundColor: "var(--disabled-color-1)", color: "var(--text-color-1)" }} disabled>
            <ArrowRightOutlined />
        </Button>)

    else
        return (<Button onClick={onClick} style={buttonStyle}>
            <ArrowRightOutlined />{children}
        </Button>)

}

export function BackButton({ specificPage = -1 }) {

    const navigate = useNavigate();

    return (
        <NavigationButton
            onClick={() => navigate(specificPage)}>
            <ArrowLeftOutlined />
        </NavigationButton>
    )
}

export function NavigationButton({ children, onClick = () => true }) {



    return (
        <Button
            onClick={onClick}
            style={{
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '40px',
                // minWidth: '40px',
                paddingLeft: "12px",
                paddingRight: "12px"
            }}
        >
            {children}

        </Button>
    )
}

// Download results button
export const CustomDownloadButton = ({ children, onClick = () => true, disabled = false, loading = false }) => {

    // Common download-button style
    const buttonStyle = {
        backgroundColor: "var(--primary-color-2)",
        color: "var(--button-text-color)",
        fontWeight: "var(--button-font-weight-strong)",
        border: 0,
        display: "flex",
        alignItems: "center",
        gap: "8px"
    };

    if (disabled)
        return (<Button style={{ ...buttonStyle, backgroundColor: "var(--disabled-color-1)", color: "var(--text-color-1)" }} disabled>
            <DownloadOutlined />
            {children}
        </Button>)

    else
        return (<Button onClick={onClick} loading={loading} style={buttonStyle}>
            <DownloadOutlined />
            {children}
        </Button>)

}
